<script lang="ts">var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a, _b, _c, _d, _e, _f, _g;
import SocialLoginCard from "../SocialLoginCard/SocialLoginCard.svelte";
import { YinzCamCardsServiceElement } from 'yinzcam-cards';
import CardBase from '../../../common/CardBase.svelte';
import { findSourceStore, getHrefForMediaItem } from '../../../utilities';
import { Readable } from 'svelte/store';
import { CardsDataSourceRegistration } from '../../../common/CardsDataSourceRegistration';
import { Popup, Link } from 'framework7-svelte';
import { onMount } from 'svelte';
import { f7 } from 'framework7-svelte';
import { Device } from "framework7";
import { JanusSignonManagerToken } from "../../../../../js/sso";
import { getToken } from 'inversify-token';
import ROOT from '../../../../../inversify.config';
import { CardsTabContext, CardsTabContextKey } from '../../../common/context';
import { getContext } from 'svelte';
import { resolveUrl } from '../../../../../js/url';
import { ycSSOThirdPartyAuth } from '../../../../../js/ycapp';
import { ycSSOSetState } from '../../../../../js/ycapp';
export let element;
export let sources;
export let sourceStore;
const signonManager = getToken(ROOT, JanusSignonManagerToken);
$: clientConfig = ((_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a.clientConfig) || {};
$: nextPage = ((_b = element === null || element === void 0 ? void 0 : element.data) === null || _b === void 0 ? void 0 : _b.nextPage) || undefined;
$: nextPageExistingAccount = ((_c = element === null || element === void 0 ? void 0 : element.data) === null || _c === void 0 ? void 0 : _c.nextPageExistingAccount) || undefined;
$: endWorkflowExistingAccount = ((_d = element === null || element === void 0 ? void 0 : element.data) === null || _d === void 0 ? void 0 : _d.endWorkflowExistingAccount) || undefined;
$: useSportsAllianceLogin = ((_e = element === null || element === void 0 ? void 0 : element.data) === null || _e === void 0 ? void 0 : _e.useSportsAllianceLogin) || false;
$: showLoginText = ((_f = element === null || element === void 0 ? void 0 : element.data) === null || _f === void 0 ? void 0 : _f.showLoginText) || false;
$: endWorkflow = (_g = element === null || element === void 0 ? void 0 : element.data) === null || _g === void 0 ? void 0 : _g.endWorkflow;
function afterConnect(existingAccount) {
    if (existingAccount && nextPageExistingAccount) {
        resolveUrl(nextPageExistingAccount).func();
    }
    else if (endWorkflow || (existingAccount && endWorkflowExistingAccount)) {
        signonManager.fireWorkflowEndEvent();
    }
    else if (nextPage) {
        resolveUrl(nextPage).func();
    }
    else if (signonManager.skipCompleteProfilePage) {
        resolveUrl(`ConnectAccounts`).func();
    }
    else {
        resolveUrl(`CompleteProfile`).func();
    }
}
const onConnect = () => {
    ycSSOThirdPartyAuth("APPLE", clientConfig, (method, clientResult) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        console.log("ycSSOThirdPartyAuth callback inside APPLE", method, clientResult);
        if (!(clientResult === null || clientResult === void 0 ? void 0 : clientResult.authorizationCode)) {
            console.warn(`ycSSOThirdPartyAuth callback for ${method}: no authorizationCode in client result`);
            return;
        }
        let result;
        f7.preloader.show('white');
        try {
            if (useSportsAllianceLogin) {
                result = yield signonManager.loginWithSportsAllianceSocialAccount('Apple', clientResult.authorizationCode);
            }
            else {
                result = yield signonManager.loginWithAppleAccount(clientResult.clientId, clientResult.clientData, clientResult.authorizationCode);
            }
        }
        finally {
            f7.preloader.hide();
        }
        if (result.success) {
            const existingAccount = result.data.AccountCreated !== 'true';
            ycSSOSetState(!existingAccount, result.data.YinzId, parseInt(result.data.ValidSpan), result.data.Ticket);
            afterConnect(existingAccount);
        }
        else {
            alert(((_b = (_a = result.data) === null || _a === void 0 ? void 0 : _a.UserMessage) === null || _b === void 0 ? void 0 : _b.Content) || 'An error occurred.');
            signonManager.fireWorkflowEndEvent();
        }
    }));
};
</script>

<CardBase {element}>
    {#if Device.ios}
    <SocialLoginCard 
        label={(showLoginText)? 'Sign in with Apple' : ''}
        image={'/static/icons/icon-apple-logo-only.png'}
        backgroundColor="black"
        textColor="white"
        borderColor="black"
        onConnect={onConnect}
        {sources}
    />
    {/if}
</CardBase>
